// http://stackoverflow.com/questions/11854514/is-it-possible-to-make-a-tree-view-with-angular

var module = angular.module('octopusApp.configuration');

module.directive("serverActivity", function($compile) {
  return {
    restrict: "E",
    scope: {
      activity: '='
    },
    templateUrl: 'areas/configuration/diagnostics/views/server_activity.html',
    compile: function(el, attr) {
      var contents = el.contents().remove();
      var compiledContents;
      return function(scope, _el, _attr) {
        if(!compiledContents) {
          compiledContents = $compile(contents);
        }
        compiledContents(scope, function(clone, scope) {
          _el.append(clone);
        });
      };
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/diagnostics/directives/server_activity.js
// module id = 647457233362100
// module chunks = 1